import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import DefaultTable, { Line } from "../../ui-library/CustomTable/DefaultTable";
import moment from "moment";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { getBaseDateFormat, UNIT } from "../../../modules/constants";
import { useTranslation } from "react-i18next";
import { decimalPlaces } from "../../../helpers/mealsHelper";
import { isRtl } from "../../../i18n/helpers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 60px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const DailyTargetsHistory = (props) => {
  const { onClose, getData, searchedParams, totalitems, theme, history } =
    props;

  const { t } = useTranslation();

  const defaultProps = {
    headers: [
      { label: t("appText.date"), key: "date" },
      { label: t("appText.dietDiary.calories"), key: "calories" },
      {
        label: isRtl()
          ? t("appText.dietDiary.longChainFats")
          : t("appText.dietDiary.lcf"),
        key: "lcf",
      },
      {
        label: isRtl()
          ? t("appText.dietDiary.mediumChainFats")
          : t("appText.dietDiary.mcf"),
        key: "mcf",
      },
      { label: t("appText.dietDiary.protein"), key: "protein" },
      { label: t("appText.dietDiary.carbohydrates"), key: "carbohydrates" },
    ],
    hasSearch: 0,
    haspagesizefilter: 0,
    haspagination: 1,
    smallTable: true,
    searchedParams,
    getData,
  };

  return (
    <Container data-testid="daily-targets-history">
      <DefaultTable
        {...defaultProps}
        maincolor={theme?.gray}
        totalitems={totalitems}
      >
        {history?.map((history, index) => (
          <Line key={`${history.Key}_${index}`}>
            <span>
              {moment
                .utc(history.updatedAt)
                .utcOffset(history.timeZoneOffset)
                .format(getBaseDateFormat())}
            </span>
            <span>{`${Number(history.calories || 0).toFixed(
              decimalPlaces
            )}kcal`}</span>
            <span>
              {`${Number(history.longChainFatsPercentage || 0).toFixed(
                decimalPlaces
              )}${UNIT.PERCENTAGE}`}
            </span>
            <span>
              {`${Number(history.mediumChainFatsPercentage || 0).toFixed(
                decimalPlaces
              )}${UNIT.PERCENTAGE}`}
            </span>
            <span>
              {`${Number(history.proteinPercentage || 0).toFixed(
                decimalPlaces
              )}${UNIT.PERCENTAGE}`}
            </span>
            <span>
              {`${Number(history.carbohydratesPercentage || 0).toFixed(
                decimalPlaces
              )}${UNIT.PERCENTAGE}`}
            </span>
          </Line>
        ))}
      </DefaultTable>
      {onClose && (
        <ActionButtonsContainer>
          <PrimaryButton data-testid="close-button" onClick={onClose}>
            {t("appText.close")}
          </PrimaryButton>
        </ActionButtonsContainer>
      )}
    </Container>
  );
};

DailyTargetsHistory.defaultProps = {
  onClose: null,
};

DailyTargetsHistory.propTypes = {
  onClose: PropTypes.func,
  searchedParams: PropTypes.object.isRequired,
  getData: PropTypes.func.isRequired,
  totalitems: PropTypes.number,
  history: PropTypes.array.isRequired,
};

export default withTheme(DailyTargetsHistory);
